import { render, staticRenderFns } from "./ViewPaymentTermPage.vue?vue&type=template&id=923430bc"
import script from "./ViewPaymentTermPage.vue?vue&type=script&lang=js"
export * from "./ViewPaymentTermPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports